// What a player can do right now, worked out from the keyboard hints the game already produces
// (alternating key and action, e.g. ['E', 'greet the trader', 'W A S D', 'walk']). The action dock
// on screen and the buttons on a phone both read these tables, so they always agree.

// hint key name -> the key the input layer listens for
export const KEYS = { E: 'e', F: 'f', G: 'g', H: 'h', J: 'j', L: 'l', Tab: 'Tab', B: 'b', T: 't', N: 'n', M: 'm', V: 'v', X: 'x', R: 'r', C: 'c', I: 'i', O: 'o', Enter: 'Enter', Escape: 'Escape', Shift: 'Shift', Space: ' ' };
// actions the stick or the mouse already cover: no button for these
export const SKIP = new Set(['walk', 'go, brake', 'steer', 'fly', 'piece']);
// keys that mean "do the thing in front of you": they go in the dock, the rest behind "more"
export const CONTEXT = new Set(['E', 'C', 'F', 'G', 'J', 'Click', 'X', 'R']);
import { t } from '../../shared/i18n.js';
// long hints cut down to fit a button, in the player's language; the captured part is translated too
export const LABELS = [[/^greet the (.+)/, 'Greet the {who}', 'who'], [/^greet/, 'Greet'], [/^work your shift at (.+)/, 'Work: {place}', 'place', true], [/^drive the (.+)/, 'Drive {what}', 'what'], [/^find a passenger/, 'Find passenger'], [/^give up/, 'Give up ride'], [/^back on foot/, 'On foot'], [/^stop building/, 'Stop building'], [/^coach to (\w+).*/, 'Coach to {to}', 'to', true], [/^chop (.+?), (.+)/, 'Chop {food} · {price}', 'food,price'], [/^at home: .*/, 'At home'], [/^land here/, 'Land here']];
// an icon for an action, by what it says
const ICON_BY_LABEL = [[/^greet/, 'person'], [/^work/, 'briefcase'], [/^chop/, 'bowl'], [/^drive|^get out/, 'car'], [/^coach/, 'bus'], [/passenger|ride/, 'taxi'], [/^land/, 'land'], [/^place|^remove|^turn|^colour/, 'build'], [/^at home/, 'home'], [/^phone/, 'phone'], [/^map/, 'map'], [/^chat/, 'chat'], [/^drone/, 'drone'], [/^town/, 'council'], [/^news/, 'news'], [/^mission/, 'pin'], [/^my places/, 'pin'], [/^build/, 'build'], [/^horn/, 'bell'], [/^handbrake|^jump|^run|^fast/, 'bolt']];

export function shortLabel(does) {
  for (const [from, to, names, raw] of LABELS) {
    const m = does.match(from);
    if (!m) continue;
    const vars = {};
    if (names) names.split(',').forEach((n, k) => { vars[n] = raw ? m[k + 1] : t(m[k + 1]); });
    return t(to, vars);
  }
  const word = t(does);
  return word.charAt(0).toUpperCase() + word.slice(1);
}

export function iconFor(does) {
  for (const [from, name] of ICON_BY_LABEL) if (from.test(does)) return name;
  return 'hand';
}

// Splits the hint pairs into the actions for the dock (at most three) and the rest.
export function splitHint(parts) {
  const primary = [];
  const rest = [];
  for (let i = 0; i < parts.length; i += 2) {
    const key = parts[i];
    const does = parts[i + 1];
    if (SKIP.has(does)) continue;
    const contextual = CONTEXT.has(key) || (key === 'Enter' && /^land/.test(does)) || (key === 'I' && /^at home/.test(does));
    if (contextual && primary.length < 3) primary.push([key, does]);
    else rest.push([key, does]);
  }
  return { primary, rest };
}

// The input key for a hint key name, or null when the stick or mouse covers it.
export function keyFor(name) {
  if (name === 'Click') return 'click';
  return KEYS[name] || null;
}
